module.exports = __webpack_public_path__ + "static/img/help4.4d6f2ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/help4.png
// module id = mB1O
// module chunks = 1